<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row">
      <div class="col-sm-4 col-12">
        <el-form-item
          :label="L10n('po-date')"
          prop="poDate"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <date-picker
            v-model="form.poDate"
            @change="updateModelItem('poDate', { required: true })"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-sm-4 col-12">
        <el-form-item
          :label="L10n('priority')"
          prop="priorityID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-response
            :model.sync="form.priorityID"
            @update:model="updateModelItem('priorityID', { required: true })"
            :isLoading="dataSourcePriority.loading"
            :data="dataSourcePriority.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-sm-4 col-12">
        <el-form-item
          :label="L10n('payment-term')"
          prop="paymentTermID"
          class="material-style">
          <select-response
            :model.sync="form.paymentTermID"
            @update:model="updateModelItem('paymentTermID')"
            :isLoading="dataSourcePaymentTerm.loading"
            :data="dataSourcePaymentTerm.records"
          ></select-response>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-12">
        <el-form-item
          :label="L10n('customer')"
          prop="customerCompanyID"
          :rules="getValidationRule('required')"
          class="material-style"
          :clearable="false"
        >
          <select-company
            :model.sync="form.customerCompanyID"
            @on-change="(id) => mixChangeCustomerID(id)"
            @on-created="mixCreateCustomer"
          >
          </select-company>
        </el-form-item>
      </div>
      <div class="col-sm-6 col-12">
        <el-form-item
          :label="L10n('customer-contact')"
          prop="customerContactID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-company-contact
            :model.sync="form.customerContactID"
            :companyID="form.customerCompanyID"
            @update:model="updateModelItem('customerContactID', { required: true })"
          ></select-company-contact>
        </el-form-item>
      </div>
      <div class="col-sm-6 col-12">
        <el-form-item
          :label="L10n('customer-detail')"
          prop="customerCompanyDetailID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-company-detail
            withAutoSelect
            :model.sync="form.customerCompanyDetailID"
            :companyID="form.customerCompanyID"
            @update:model="updateModelItem('customerCompanyDetailID', { required: true })"
          ></select-company-detail>
        </el-form-item>
      </div>
      <div class="col-sm-6 col-12">
        <el-form-item
          :label="L10n('customer-forwarder')"
          prop="customerForwarderID"
          class="material-style"
          :clearable="false"
        >
          <select-forwarder
            :companyID="form.customerCompanyID"
            :model.sync="form.customerForwarderID"
            @update:model="updateModelItem('customerForwarderID', { required: false })"
          ></select-forwarder>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-12">
        <el-form-item
          :label="L10n('ship-to-company')"
          prop="shipToCompanyID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-company
            :model.sync="form.shipToCompanyID"
            @on-created="mixCreateShipTo"
            @on-change="(id) => mixChangeShipToID(id, { required: true })"
          >
          </select-company>
        </el-form-item>
      </div>
      <div class="col-sm-6 col-12">
        <el-form-item
          :label="L10n('ship-to-company-contact')"
          prop="shipToContactID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-company-contact
            :model.sync="form.shipToContactID"
            :companyID="form.shipToCompanyID"
            @update:model="updateModelItem('shipToContactID', { required: true })"
          ></select-company-contact>
        </el-form-item>
      </div>
      <div class="col-12">
        <el-form-item
          :label="L10n('ship-to-company-detail')"
          prop="shipToCompanyDetailID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-company-detail
            :model.sync="form.shipToCompanyDetailID"
            :companyID="form.shipToCompanyID"
            @update:model="updateModelItem('shipToCompanyDetailID', { required: true })"
          ></select-company-detail>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import { mixUpdateCustomer, mixUpdateShipTo } from '@/mixins/companies'
export default {
  name: 'FormRFQ',
  mixins: [Form, mixUpdateCustomer, mixUpdateShipTo],
  components: {
    'select-forwarder': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectForwarder/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'select-company-contact': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyContact/Index.vue'),
    'select-company-detail': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyDetail/Index.vue')
  },
  computed: {
    dataSourcePriority () {
      return this.API('Priorities/GetAllDynamic?select=id,title&orderBy=title')
    },
    dataSourcePaymentTerm () {
      return this.API('PaymentTerms/GetAllDynamic?select=id,title&orderBy=title')
    }
  }
}
</script>
